import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  Box,
  Button,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { ApiServices } from "../../../utils/ApiService";

export default function FileFormatMasterPage() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [fileFormats, setFileFormats] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch all file formats
  useEffect(() => {
    fetchFileFormats();
  }, []);

  const fetchFileFormats = async () => {
    setLoading(true);
    try {
      const res = await ApiServices.get("file-format/file-format-list");
      setFileFormats(res?.data?.fileFormats || []);
    } catch (err) {
      console.error("Error fetching file formats:", err);
      enqueueSnackbar("Error loading file formats", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  // Delete a file format
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      const userId = JSON.parse(localStorage.getItem("user"))?.id || null;
      await ApiServices.delete(`file-format/file-format-delete/${id}`, {
        params: { deleted_by: userId }
      });
      enqueueSnackbar("File format deleted successfully", { variant: "success" });
      fetchFileFormats();
    } catch (err) {
      console.error("Error deleting file format:", err);
      enqueueSnackbar("Error deleting record", { variant: "error" });
    }
  };

  // Add new file format
  const handleAdd = () => navigate("/settings/file-format-add");

  // Edit on double click
  const handleRowDoubleClick = (params) => {
    navigate(`/settings/file-format-edit/${params.id}`);
  };

  // Grid Columns
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "doc_category_name", headerName: "Document Category", flex: 1 },
    { field: "doc_type_name", headerName: "Document Type", flex: 1 },
    { field: "from_or_thereafter", headerName: "From / Thereafter", width: 160 },
    {
      field: "doc_possession_name",
      headerName: "Possession",
      flex: 1
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => (
        <IconButton
          color="error"
          onClick={() => handleDelete(params.id)}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Paper sx={{ p: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">File Format Master</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdd}>
          Add
        </Button>
      </Box>

      <Box>
        <div style={{ height: 400, marginTop: 16 }}>
          <DataGrid
            rows={fileFormats}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            onRowDoubleClick={handleRowDoubleClick}
            getRowId={(row) => row.id}
            loading={loading}
          />
        </div>
      </Box>
    </Paper>
  );
}
